module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "materBinding"
    }
  }, [_c('el-form', {
    ref: "searchForm",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "inline": true,
      "model": _vm.searchForm,
      "label-position": _vm.labelPosition
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "200px",
      "margin-bottom": "15px"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "品牌",
      "clearable": ""
    },
    on: {
      "change": _vm.selectBrand
    },
    model: {
      value: (_vm.searchForm.brandId),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "brandId", $$v)
      },
      expression: "searchForm.brandId"
    }
  }, _vm._l((_vm.brandLists), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.brandName,
        "value": item.brandId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "200px",
      "margin-bottom": "15px"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "品类",
      "clearable": ""
    },
    on: {
      "change": _vm.selectCategory
    },
    model: {
      value: (_vm.searchForm.categoryId),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "categoryId", $$v)
      },
      expression: "searchForm.categoryId"
    }
  }, _vm._l((_vm.categoryLists), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.categoryName,
        "value": item.categoryId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "200px",
      "margin-bottom": "15px"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "型号",
      "clearable": ""
    },
    on: {
      "change": _vm.selectModel
    },
    model: {
      value: (_vm.searchForm.modelId),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "modelId", $$v)
      },
      expression: "searchForm.modelId"
    }
  }, _vm._l((_vm.modelLists), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.modelName,
        "value": item.modelId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "200px",
      "margin-bottom": "15px"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "故障大类",
      "clearable": ""
    },
    on: {
      "change": _vm.selectFaultClass
    },
    model: {
      value: (_vm.searchForm.faultTypesId),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "faultTypesId", $$v)
      },
      expression: "searchForm.faultTypesId"
    }
  }, _vm._l((_vm.faultClassLists), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.faultTypesName,
        "value": item.faultTypesId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-select', {
    staticClass: "guzhang",
    staticStyle: {
      "width": "240px",
      "margin-bottom": "10px",
      "margin-right": "10px"
    },
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "故障小类"
    },
    on: {
      "change": _vm.selectSubClass
    },
    model: {
      value: (_vm.searchForm.faultSubclassId),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "faultSubclassId", $$v)
      },
      expression: "searchForm.faultSubclassId"
    }
  }, _vm._l((_vm.faultLists), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.faultSubclassName,
        "value": item.faultSubclassId
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-card', {
    staticClass: "box-card"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.returnData,
      "border": "",
      "header-cell-style": {
        'text-align': 'center'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "modelName",
      "label": "型号",
      "width": "250"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "colorName",
      "label": "颜色",
      "width": "250"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "materialName",
      "label": "物料名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "materialCode",
      "label": "物料编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "120",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.materialCode && _vm.basicsAuth.insertColorMaterial) ? _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.createBtn(scope.$index, scope.row)
            }
          }
        }, [_vm._v("新增")]) : _vm._e(), _vm._v(" "), (scope.row.materialCode && _vm.basicsAuth.updateColorMaterial) ? _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.exitBtn(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]) : _vm._e()]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.textMenu[_vm.dialogMenuStatus],
      "visible": _vm.dislogCreate,
      "close-on-click-modal": false,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dislogCreate = $event
      },
      "close": function($event) {
        return _vm.emptyDialog('materForm')
      }
    }
  }, [_c('el-form', {
    ref: "materForm",
    attrs: {
      "model": _vm.materForm,
      "label-width": "100px",
      "label-position": _vm.labelPosition
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "型号名称："
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.materForm.modelName),
      callback: function($$v) {
        _vm.$set(_vm.materForm, "modelName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "materForm.modelName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "颜色："
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.materForm.colorName),
      callback: function($$v) {
        _vm.$set(_vm.materForm, "colorName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "materForm.colorName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "物料名称："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请选择物料名称",
      "autocompelete": "off",
      "filterable": ""
    },
    on: {
      "change": _vm.getMaterialCode
    },
    model: {
      value: (_vm.materForm.materialCoding),
      callback: function($$v) {
        _vm.$set(_vm.materForm, "materialCoding", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "materForm.materialCoding"
    }
  }, _vm._l((_vm.MaterialLists), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.materialName,
        "value": item.materialCoding
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "物料编号："
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.materForm.materialCode),
      callback: function($$v) {
        _vm.$set(_vm.materForm, "materialCode", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "materForm.materialCode"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.dialogMenuStatus !== 'update') ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.addEventFormSubmitBtn('materForm')
      }
    }
  }, [_vm._v("添加")]) : _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.saveEventFormSubmitBtn('materForm')
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.emptyDialog('materForm')
      }
    }
  }, [_vm._v("取 消")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-2b750454","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/basicSetting/materBinding.vue
// module id = 1626
// module chunks = 0